<template>
  <div class="ws-container">
    <div class="ws-chart-container">
      <div class="ws-chart" ref="myChart"></div>
      <!-- 百分率 -->
      <div class="connect">
        <span ref="connect">
          {{ ((item.number / item.total) * 100).toFixed(0) }}
        </span>
        %
      </div>
      <div class="storage">
        <span ref="storage">
          {{ (((item.total - item.number) / item.total) * 100).toFixed(0) }}
        </span>
        %
      </div>
      <!-- 内圆环 -->
      <div class="ring"></div>
      <div class="ring-second"></div>
      <img
        class="circle"
        ref="circle"
        src="../../../assets/main/circle-d.png"
        alt=""
      />
      <img class="icon" src="../../../assets/main/Wi-Fi-2.png" />
    </div>
    <div class="ws-data">
      <div>
        <div class="title">当前Wi-Fi连接数</div>
        <div class="num" ref="number">{{ this.item.number }}</div>
        <div class="ws-item">
          <div class="sport"></div>
          <div>Wi-Fi连接比例</div>
        </div>
        <div class="ws-item">
          <div class="sport green"></div>
          <div>Wi-Fi暂存比例</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {}
    },
    mounted() {
      this.$nextTick(() => {
        this.init()
      })
    },
    beforeDestroy() {
      this.$animejs.remove([
        this.$refs.circle,
        this.$refs.number,
        this.$refs.connect,
        this.$refs.storage,
      ])
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option
        let trafficWay = [
          {
            value: this.item.number,
          },
          {
            value: this.item.total - this.item.number,
          },
        ]

        let data = []
        let color = ['#2084FF', '#00FFAC']
        for (let i = 0; i < trafficWay.length; i++) {
          data.push(
            {
              value: trafficWay[i].value,
              itemStyle: {
                normal: {
                  borderWidth: 6,
                  shadowBlur: 10,

                  borderRadius: 10,
                  borderColor: color[i],
                  shadowColor: color[i],
                },
              },
            },
            {
              value: Math.ceil(this.item.total * 0.02),
              name: '',
              itemStyle: {
                normal: {
                  label: {
                    show: false,
                  },
                  labelLine: {
                    show: false,
                  },
                  color: 'rgba(0, 0, 0, 0)',
                  borderColor: 'rgba(0, 0, 0, 0)',
                  borderWidth: 0,
                },
              },
            }
          )
        }
        let seriesOption = [
          {
            name: '',
            type: 'pie',
            clockWise: false,
            radius: [80, 80],
            width: 100,
            height: 100,
            hoverAnimation: false,
            center: ['50%', '55%'],
            left: '26%',
            top: 'center',
            itemStyle: {
              normal: {
                label: {
                  show: false,
                },
              },
            },
            data: data,
          },
        ]
        option = {
          color: color,
          graphic: {
            elements: [
              {
                type: 'image',
                z: 3,
                style: {
                  // image: img,
                  width: 100,
                  height: 100,
                },
                left: '20%',
                top: 'center',
              },
            ],
          },
          tooltip: {
            show: false,
          },
          toolbox: {
            show: false,
          },
          series: seriesOption,
        }
        myChart.setOption(option)
        // 圆环转动
        this.$animejs({
          targets: this.$refs.circle,
          easing: 'linear',
          loop: true,
          translateY: [5, 5],
          rotate: 360,
          duration: 10000,
        })
        // 数字滚动动画
        this.$animejs({
          targets: this.$refs.number,
          innerHTML: [0, this.item.number],
          cycles: 130,
          round: 1,
          easing: 'linear',
        })
        this.$animejs({
          targets: this.$refs.connect,
          innerHTML: [
            0,
            ((this.item.number / this.item.total) * 100).toFixed(0),
          ],
          cycles: 130,
          round: 1,
          easing: 'linear',
        })
        this.$animejs({
          targets: this.$refs.storage,
          innerHTML: [
            0,
            (
              ((this.item.total - this.item.number) / this.item.total) *
              100
            ).toFixed(0),
          ],
          cycles: 130,
          round: 1,
          easing: 'linear',
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .ws-container {
    display: flex;
    flex-direction: row;
    .ws-chart-container {
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .ws-chart {
        width: 10.9375vw;
        height: 10.9375vw;
      }
      .connect,
      .storage {
        position: absolute;
        z-index: 9;
        color: white;
      }
      .connect {
        left: 2.6041vw;
        top: 3.3854vw;
      }
      .storage {
        left: 6.7187vw;
        top: 6.6145vw;
      }
      // 内部圆环
      .ring {
        background-color: #192d35;
        width: 7.8125vw;
        height: 7.8125vw;
        top: 1.875vw;
        border-radius: 50%;
        position: absolute;
        z-index: 2;
      }
      .ring-second {
        background-color: #141a1c;
        width: 6.7708vw;
        height: 6.7708vw;
        top: 2.343vw;
        border-radius: 50%;
        position: absolute;
        z-index: 3;
      }
      .circle {
        position: absolute;
        width: 5.7291vw;
        z-index: 4;
        transform: translateY(5px);
      }
      .icon {
        position: absolute;
        width: 2.0833vw;
        z-index: 5;
        transform: translateY(5px);
        transition: all 0.3s;
      }
      .icon:hover {
        transform: scale(1.1);
      }
    }
    .ws-data {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: center;
      flex-grow: 1;
      color: #e6e6e6;
      font-size: 14px;
      padding: 0 0.5208vw;
      .title {
        font-size: 16px;
        color: white;
      }
      .num {
        font-size: 1.1458vw;
        color: #ff943d;
        margin-top: 0.5208vw;
      }
      .ws-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 1.25vw;
        .sport {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #207bf7;
          margin-right: 0.5208vw;
        }
        .sport.green {
          background-color: #02ffa3;
        }
      }
    }
  }
</style>
